var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"cust-button",style:(_vm.custStyle),attrs:{"variant":"link","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }